<template>
  <div class="parent-container container-fluid container-sm flex-sm-column flex-md-column flex-lg-row pb-5">

    <div class="col-sm-12 col-md-12 col-lg-8">
      <div class="parent-container__child-1 col-12">
        <slot name="order-info"></slot>
      </div>

      <div class="parent-container__child-2 col-12">
        <slot name="vehicle-info"></slot>
      </div>

      <div class="parent-container__child-3 col-12">
        <slot name="payment-type"></slot>
      </div>
    </div>

    <div class="col-sm-12 col-md-12 col-lg-4">
      <div class="parent-container__child-4 col-12">
        <slot name="order-form"></slot>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import './vehicleOrderTemplate.scss';
import {defineComponent} from "vue";
export default defineComponent({
  name: 'VehicleOrderTemplateComponent',
  components: {},
  props: {},

})
</script>

<style lang="scss">

.parent-container {
  padding-top: 3.5rem;
  display: flex;
}


.hr-line {
  border: 1px solid #DEDEDE;
  margin-bottom: 2rem;
}


</style>